import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LandingDomainGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean {
    const currentDomain = window.location.origin;
    const allowedDomain = environment.workflow;

    const isLocalhost = currentDomain.includes('localhost');

    if (isLocalhost || currentDomain === allowedDomain) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
